<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="系统日志详情" v-if="mdl">
        <detail-list-item term="报警编号">{{ mdl.code }}</detail-list-item>
        <detail-list-item term="终端类型">{{ mdl.terminalTypeName }}</detail-list-item>
        <detail-list-item term="终端编号">{{mdl.terminalCode}}</detail-list-item>
        <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
        <detail-list-item term="工单编号">{{ mdl.orderNo }}</detail-list-item>
        <detail-list-item term="报警信息">{{ mdl.msg }}</detail-list-item>
        <detail-list-item term="报警等级">{{ mdl.levelName }}</detail-list-item>
        <detail-list-item term="处理结果">{{mdl.handResult}}</detail-list-item>
        <detail-list-item term="报警状态">{{mdl.statusName}}</detail-list-item>
        <detail-list-item term="原因说明">{{mdl.cause}}</detail-list-item>
        <detail-list-item term="报警类型">{{mdl.typeName}}</detail-list-item>
        <detail-list-item term="报警时间">{{mdl.createTime | formatDate}}</detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import storage from "@/utils/storage"

const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let cache = storage.fetch("cache-AlarmDetail")
      if (cache){
          this.mdl = JSON.parse(cache);
      } 
    }
  }
}
</script>



